import { Component, OnInit, ViewChild,HostListener } from '@angular/core';
import { HelperService } from '../helper.service';
import { Subject } from 'rxjs/Subject';
import { Http, Response,Headers } from '@angular/http';
import 'rxjs/add/operator/map';
import { DataTableDirective } from 'angular-datatables';
import {MatSnackBar} from '@angular/material';
import { NgForm } from '@angular/forms';
import { Router,ActivatedRoute, Params } from '@angular/router';
import {CookieService} from 'angular2-cookie/core';
import {SnackbarComponent} from '../snackbar/snackbar.component';

class Syllabus {
  id: number=0;
  name: string='';

}
@Component({
  selector: 'app-record',
  templateUrl: './record.component.html',
  styleUrls: ['./record.component.css'],
  providers: [HelperService] 
})

export class RecordComponent implements OnInit {
  // 	@HostListener('window:beforeunload', ['$event'])
//   unloadHandler(event: Event) {
//   localStorage.removeItem('access_token');
//   localStorage.removeItem('navigateroute');
// }
  @ViewChild(DataTableDirective)

  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();
  syllabuses: Syllabus[] = [];
  dtElement: DataTableDirective;

  list=true;
  edit=false;
  add=false;
  icon=this.helper.add_icon;
  icon_action='addClick';
  syllabus='';
  syllabus_id=0;
  msg="";
  user_permissions:any=[];
  user=this.cookie.get('user_id');
  datas;
  user_roleid;checkIfTeacher;
  teacherroles;
  user_token= localStorage.getItem('access_token');
  private headers: Headers = new Headers({
  'Accept': 'application/json',
  'Authorization': "Bearer "+this.user_token
});
  
  constructor(private helper:HelperService,private http:Http,private snackbar: MatSnackBar,private router: Router,private cookie:CookieService) {
   
  }

  ngOnInit() {
    let user=this.cookie.get('user_id');
    this.http.get(this.helper.base_url+'/http/get/user/permissions',{ headers: this.headers })
    
    .subscribe(data => {
      this.user_permissions = JSON.parse(data['_body']);
     //console.log(this.user_permissions);
        
     
    });
    this.http.get(this.helper.base_url+'http/get/checkusers',{ headers: this.headers })
    
    .subscribe(data => {
      let body = JSON.parse(data['_body']);
      // this.datas = JSON.parse(data['_body']).users[0];
      // this.user_roleid = JSON.parse(data['_body']).users[0]['role_id'];
      // //console.log(this.datas);
      // this.teacherroles = JSON.parse(data['_body']).teacherroles;
      // console.log(this.teacherroles);
      // console.log(this.user_roleid);
      //console.log(this.teacherroles.includes(this.user_roleid));
      //this.checkIfTeacher = this.teacherroles.includes(this.user_roleid);
      this.checkIfTeacher = body.success;
      if(this.checkIfTeacher == false)
      {
        this.dtOptions = {
          pagingType: 'full_numbers',
          pageLength: 10
        };
        
        this.http.get(this.helper.base_url+'http/get/syllabus',{ headers: this.headers })
        .map(this.extractData)
          .subscribe(syllabuses => {
          // console.log(syllabuses);
            this.syllabuses = syllabuses;
          
              this.dtTrigger.next();

          
          });
        }
        else
        {
          //alert("teacher");
          this.dtOptions = {
            pagingType: 'full_numbers',
            pageLength: 10
          };
          
          this.http.get(this.helper.base_url+'http/get/syllabus/teacher',{ headers: this.headers })
          .map(this.extractData)
            .subscribe(syllabuses => {
            // console.log(syllabuses);
              this.syllabuses = syllabuses;
            
                this.dtTrigger.next();
  
            
            });
        }
    
    });
  }
  

  editClick(id,name){
    this.list=false;
    this.edit=true;
    this.add=false;
    this.icon=this.helper.list_icon;
    this.icon_action="listClick";
    this.syllabus=name;
    this.syllabus_id=id;
  }
  addClick(e){
    
    this.list=false;
    this.edit=false;
    this.add=true;
    this.icon=this.helper.list_icon;
    
    this.icon_action="listClick";
  }
  listClick(e){
    this.list=true;
    this.edit=false;
    this.add=false;
    this.icon=this.helper.add_icon;
    this.icon_action="addClick";
  }
  delete_syllabusClick(id){
    let snackBarRef = this.snackbar.openFromComponent(SnackbarComponent, {
    //this.snackbar.open('Are you sure!', 'Delete', {
      duration: 3000,
      extraClasses:  ['warning-snackbar'],
    }).onAction().subscribe(() => {
      this.http.get(this.helper.base_url+'http/delete/syllabus/'+id,{ headers: this.headers })
      .subscribe(
          //this.msg = "Syllabus deleted successfully";
          (data) =>{
            let body = JSON.parse(data['_body']);
            if(body.success == 1)
            {
              this.listClick(null) ;
              this.refresh(false,body.message) ;
            }
            else
            {
              this.snackbar.open(body.message, null, {
                duration:5000,
                  extraClasses:'error-snackbar',
                  verticalPosition:'top'
                });
            }
            // this.refresh(false,"Syllabus deleted successfully")
          } , //For Success Response
          err => {console.error(err)} //For Error Response
      ); 
    });
  }


 refresh(val=false,msg){
  this.snackbar.open(msg, null, {
    duration:5000,
      extraClasses:'success-snackbar',
      verticalPosition:'top'
    });
  this.router.navigateByUrl('/redirect', {skipLocationChange: true}).then(()=>
  this.router.navigate(["/record"]));
  
      
 }
 addSyllabus(addForm: NgForm){
  let body = new FormData();
  body.append('name', addForm.value.name);


   this.http.post(this.helper.base_url+'http/add/syllabus', body,{ headers: this.headers })
   .subscribe(
     (res) => {
      let body = JSON.parse(res['_body']);
      //console.log(body)
       if(body.success == 1)
       {
        this.listClick(null) ;
        this.refresh(false,body.message) ;
       }
       else
       {
        this.snackbar.open(body.message, null, {
          duration:5000,
            extraClasses:'error-snackbar',
            verticalPosition:'top'
          });
       }
      // this.listClick(null) ;
      // this.refresh() ;
     }, //For Success Response
      err => {console.error(err)} //For Error Response);
   );
 }
 updateSyllabus(updateForm: NgForm){
   let id =this.syllabus_id;
  let body = new FormData();
  //console.log(updateForm);
  body.append('name', updateForm.value.name);

   this.http.post(this.helper.base_url+'http/update/syllabus/'+id, body,{ headers: this.headers })
   .subscribe(
     (res) => {
      let body = JSON.parse(res['_body']);
      console.log(body)
       if(body.success == 1)
       {
        this.listClick(null) ;
        this.refresh(false,body.message);
       }
       else
       {
        this.snackbar.open(body.message, null, {
          duration:5000,
            extraClasses:'error-snackbar',
            verticalPosition:'top'
          });
       }
      
     }, //For Success Response
      err => {console.error(err)} //For Error Response);
   );
 }

  private extractData(res: Response) {
    const body = res.json();
    return body.data || {};
  }
  publish_syllabusClick(id){
    
    // this.snackbar.open('Are you sure!', 'Delete', {
    //   duration: 50000,
    //   extraClasses:  ['warning-snackbar'],
    // }).onAction().subscribe(() => {
      this.http.get(this.helper.base_url+'http/publish/syllabus/'+id,{ headers: this.headers })
      .subscribe(
          //this.msg = "Syllabus deleted successfully";
          (data) =>{
            let body = JSON.parse(data['_body']);
            if(body.success == 1)
            {
              this.listClick(null) ;
              this.refresh(false,body.message) ;
            }
            else
            {
              this.snackbar.open(body.message, null, {
                duration:5000,
                  extraClasses:'error-snackbar',
                  verticalPosition:'top'
                });
            }
            // this.refresh(false,"Syllabus deleted successfully")
          } , //For Success Response
          err => {console.error(err)} //For Error Response
      ); 
    //});
  }

}



// WEBPACK FOOTER //
// ./src/app/record/record.component.ts